module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logout-page"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e69437a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LogoutPage.vue
// module id = 1118
// module chunks = 0